<template>
  <AppCoupon ad_mold="coupon_for_course_detail" />
</template>

<script>
import AppCoupon from '@/views/ad/components/app-coupon/app-coupon';
export default {
  name: 'AppCourseDetailCoupon',
  components: {
    AppCoupon,
  },
};
</script>
